<template>
  <div class="role">
    <div class="right-wrap">
      <el-table :data="lists" style="width: 100%" class="list">
        <template slot="empty">
          <div class="empty-wrap">
            <el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
            <div class="empty-text">暂无数据</div>
          </div>
        </template>
        <el-table-column prop="id" label="编号" class-name="id" width='60'></el-table-column>
        <el-table-column prop="phone" label="手机号" class-name="phone" width="145">
          <template slot-scope="scope">
            <div>{{ scope.row.phone ? scope.row.phone : '--' }}</div>
            <div v-if="scope.row.city">{{ scope.row.city }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="avatar" label="头像/昵称" class-name="avatar" min-width="120">
          <template slot-scope="scope">
            <div class="" style="text-align: center;">
              <el-image v-if="scope.row.avatar" class="avatar_img" :src="scope.row.avatar"
                :preview-src-list="[scope.row.avatar]"></el-image>
              <div class="">{{ scope.row.username ? scope.row.username : '--' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" class-name="sex" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.sex == 0 ? '保密' : scope.row.sex == 1 ? '男' : scope.row.sex == 2 ? '女' : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="birth" label="出生日期" class-name="birth" min-width="170px">
          <template slot-scope="scope">
            {{ scope.row.birth ? scope.row.birth : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="thislogin_ip" label="最后登录ip" class-name="thislogin_ip" min-width="120px">
          <template slot-scope="scope">
            {{ scope.row.thislogin_ip ? scope.row.thislogin_ip : '--' }}
          </template>
        </el-table-column>

        <el-table-column prop="thislogin_time" label="最后登录时间" class-name="thislogin_time" min-width="170px">
          <template slot-scope="scope">
            {{ scope.row.thislogin_time ? scope.row.thislogin_time : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="device" label="注册设备" class-name="device">
        </el-table-column>

        <el-table-column prop="created_at" label="注册时间" class-name="created_at" width="170px">
          <template slot-scope="scope">
            {{ scope.row.created_at ? scope.row.created_at : '--' }}
          </template>
        </el-table-column>

      </el-table>

      <el-pagination prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" hide-on-single-page
        :current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize" :total="pager.count"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserList } from "@/utils/axios"

export default {
  name: 'mainUserList',
  data () {
    return {
      submiting: false,//正在请求
      lists: [],
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
      companyList: [],
      pager: {
        count: 0,
        page: 1,// 默认第一页
        pagecount: 0,
        pagesize: 12//默认一页15条数据
      },
      enpId: '',
      packageList: [],
      packageVal: '',
      searchDate: '',//检索日期
      selectRowData: [],// 存储所选列表行数据
    }
  },
  mounted () {
    this.getList();
  },
  methods: {

    handleEnp (id) {
      this.pager.page = 1
      this.getList()
    },
    // 查询
    searchDateChange (daterange) {
      // this.pager.page = 1
      // this.getHistoryList();
    },
    handleChangeSelect (val) {
      // this.pager.page = 1
      // this.getHistoryList();
    },
    handleQuery () {
      this.pager.page = 1
      this.getList();
    },
    handleRet () {
      this.pager.page = 1
      this.getList();
    },
    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },
    // 获取列表
    getList () {
      // page 分页  act 操作类型
      let data = {}
      data = {
        page: this.pager.page,
        pagesize: this.pager.pagesize
      }
      getUserList(data).then(res => {
        if (res.code == 200) {
          // 历史记录列表数据
          // this.lists = res.data.data;
          let result = JSON.parse(window.atob(res.data));
          let list = result.data;
          this.lists = list

          // 分页
          var pager = result.pager;
          for (var key in pager) {
            pager[key] = parseInt(pager[key]);
          }
          this.pager = pager;
        } else {
          this.$myAlert({
            type: 'fail',
            content: res.msg
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.right-wrap>>>.el-table th {
  background-color: #F2F4FA;
  text-align: center;
}

.right-wrap>>>.el-table__body td {
  text-align: center;
}

.right-wrap>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 380px;
}

.right-wrap>>>.el-date-editor .el-range-separator {
  color: #DBDDE6;
}
</style>
<style lang="scss" scoped>
.role {
  display: flex;
  // padding: 24px;
  width: 100%;
  height: 100%;
  // border: 12px solid #F2F4FA;

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 0 24px 30px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;
    overflow-y: auto;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: #7A92FB;
      }
    }

    .left-enp-item-active {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      cursor: pointer;
    }

    .enp-item-status {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF5219;
      background-color: #FDE8E2;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }

    .enp-item-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .enp-item-status-active {
      width: 20px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6883FB;
      background-color: #DCE3FF;
      margin-right: 4px;
      padding-top: 1px;
      border-radius: 50%;
      text-align: center;
    }
  }

  .right-wrap {
    position: relative;
    min-width: 1048px;
    height: 100%;
    flex: 1;
    padding: 28px 24px;
    overflow: auto;

    .query-wrap {
      display: flex;
      align-items: center;
      // justify-content: space-between;
      margin-bottom: 16px;

      .query-package {
        width: 226px;
      }
    }

    .c-danger {
      color: #FF4C52;
    }

    .query-date {
      display: flex;
      align-items: center;
      margin-right: 40px;
      margin-left: 32px;

      .query-date-label {
        margin-right: 10px;
      }
    }

    .query-btn {
      width: 96px;
      height: 34px;
      background: #6883FB;
      border-radius: 17px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      border: none;
    }

    .el-button:active {
      background-color: #5B73DC;
    }
  }

  .foot-pagination {
    // position: absolute;
    // bottom: 0;
    width: 96%;
    padding-bottom: 20px;
    // height: 80px;
  }

  .pagination {
    width: 100%;
    margin-top: 24px;
    text-align: center;
  }

  .empty-wrap {
    padding: 100px 0;
  }

  .empty-img {
    width: 338px;
    height: 218px;
  }

}

.order_status_80 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: #5eb95e;
}

.pay_status_1 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: #dd514c;
}

.order_status_1 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  background-color: #F37B1D;
}

.avatar_img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
